/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DNSRecordInfo { 
    /**
     * Domain Name FQDNs
     */
    record_name?: string;
    /**
     * Type of Record
     */
    record_type?: string;
    /**
     * IP Address
     */
    value?: string;
}

